import { FileOpenIcon } from 'ia-react-core';
import { FC, HTMLProps } from 'react';
import styled from 'styled-components';

export const StyledDownloadIconWrapper = styled.div`
 > svg {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15px;
 }
`;

export const StyledDocumentIcon = styled<FC<HTMLProps<SVGElement>>>(FileOpenIcon)`
  color: ${({ theme }) => theme.colors.blue5};
  height: 20px;
  width:20px;
`;
